import { closeCurrentModal } from 'weblite-web-modal-viewer'
import {
  resetPanel,
  pushToPanel as pushToPanelNew,
  popFromPanel as popFromPanelNew,
  replaceInPanel as replaceInPanelNew,
  popFromSectionsHistory,
  getPanelTop,
  getPanelHistory,
  popPanelFromSection,
  getSectionTop,
  pushPanelToSection,
  pushToSectionsHistory,
  getSectionsHistoryTop,
  getSectionHistory,
  resetSection,
  resetSectionsHistory,
  removeSectionFromSectionsHistory,
} from 'weblite-router'
import { PrivacyType } from '@weblite/ts-action/user-policy'
import { HallType, InviteLink } from '@weblite/ts-action/hall'
import { VerificationSession } from '$logic/auth'
import { getClientUserId } from '$logic/client-user'
import { getPrivateSpace } from '$logic/private-space'
import { getOpenedRoomId, openRoom } from '$logic/opened-room'
import { handleLink } from '$logic/router/url'
import { resetUserPermissions } from '$logic/user-permissions'
import { urlToLoadAfterLoginStorage } from '$logic/router/storage'
import { isDesktopSize } from '$func/environmentInfo'
import { asyncDelay } from '$func/delay'
import { lastOpenedRoomMessagesService } from '$logic/last-opened-room-messages/service'

export async function initializeMainApp() {
  switchToRoomList()
  await resetPanel('room', { location: 'startPage' })
  await resetPanel('roomProfile')
}

// ****************************************************
// ****************      AUTH      ********************
// ****************************************************

// VERIFY
export async function goToAuthVerify(session: VerificationSession) {
  await pushToPanelNew('root', 'root/auth/verify', session)
}

export async function closeAuthVerify() {
  await popFromPanelNew('root')
}

export async function goToAuthSignin() {
  await pushToPanelNew('root', 'root/auth/signIn')
}

export async function goToAuthPrivacyPolicy(onBack?: () => void) {
  await pushToPanelNew('root', 'root/auth/privacyPolicy', { onBack })
}

// SIGNUP
export async function goToAuthSignup(state?: {
  name?: string
  lastName: string
  invited: boolean
}) {
  await replaceInPanelNew('root', 'root/auth/signUp', state)
}
export async function closeAuthSignup() {
  await resetPanel('root', { location: 'root/auth/signIn' })
}

// ****************************************************
// ****************     CALL      *********************
// ****************************************************
export function openCall() {
  const commSectionTop = getSectionTop('comm')
  if (commSectionTop !== 'call') pushPanelToSection('comm', 'call')

  pushToSectionsHistory('comm')
}

export function hideCall() {
  if (isDesktopSize()) removeSectionFromSectionsHistory('comm')
  else if (getSectionsHistoryTop() === 'comm') popFromSectionsHistory()
}

// ****************************************************
// ****************     PV_CALL_MANAGER      **********
// ****************************************************
export function openPvCallManager() {
  const commSectionTop = getSectionTop('comm')
  if (commSectionTop !== 'pvCallManager')
    pushPanelToSection('comm', 'pvCallManager')

  pushToSectionsHistory('comm')
}

export function isPvCallManagerOpen() {
  return getSectionTop('comm') === 'pvCallManager'
}

export function closePvCallManager() {
  hideCall()
}
// ****************************************************
// ****************     STORY      **********
// ****************************************************

export function openStoryPanel() {
  const storySectionTop = getSectionTop('story')
  if (storySectionTop !== 'story') pushPanelToSection('story', 'story')

  pushToSectionsHistory('story')
}

export async function closeStory() {
  await closeCurrentModal() // TODO: Temporary on modal format
  // if (isDesktopSize()) removeSectionFromSectionsHistory('story')
  // else if (getSectionsHistoryTop() === 'story') popFromSectionsHistory()
}

// ****************************************************
// ****************     VITRINE      ******************
// ****************************************************
export function openVitrine() {
  pushPanelToSection('channelVitrine', 'vitrine')
}

export function hideVitrine() {
  if (isDesktopSize()) removeSectionFromSectionsHistory('channelVitrine')
  else if (getSectionsHistoryTop() === 'channelVitrine')
    popFromSectionsHistory()
}

// ****************************************************
// ****************     COURSE_VITRINE      ******************
// ****************************************************
export function openCourseVitrine() {
  pushPanelToSection('courseVitrine', 'courseVitrine')
}

export function hideCourseVitrine() {
  if (isDesktopSize()) removeSectionFromSectionsHistory('courseVitrine')
  else if (getSectionsHistoryTop() === 'courseVitrine') popFromSectionsHistory()
}

// ****************************************************
// ***************      WORKBENCH       ***************
// ****************************************************
export function switchToWorkbench() {
  replaceInPanelNew('home', 'home', { tab: 'workbench' })
}

// ****************************************************
// *************      GENERAL_ISSUE       *************
// ****************************************************
export function switchToGeneralIssue() {
  replaceInPanelNew('home', 'home', { tab: 'general-issue' })
}

// ****************************************************
// ***************      ROOM_LIST      ****************
// ****************************************************

// ROOM_LIST
export function switchToRoomList() {
  // NOTE: replace should be done to update left section and activeSections history
  replaceInPanelNew('home', 'home', { tab: 'roomList' })
  resetPanel('home', { location: 'home', state: { tab: 'roomList' } })
}

// ROOM_LIST_SELECTION_MODE
export async function setRoomListToSelectionMode() {
  await pushToPanelNew('roomList', 'roomList/roomList', { mode: 'SELECT' })
}

export async function exitRoomListFromSelectionMode() {
  await popFromPanelNew('roomList')
}

// ROOM_LIST_SEARCH
export async function openRoomListSearch() {
  // await pushToPanel('OTHER', { page: 'ROOM_LIST_SEARCH' })
  await pushToPanelNew('roomList', 'roomList/search')
}

export function closeRoomListSearch() {
  popFromPanelNew('roomList')
}

// ****************************************************
// ***************      TOOL_BOX      *****************
// ****************************************************
// TOOL_BOX
export async function goBackInToolBoxPanel() {
  await closeCurrentModal()
}

export async function closeNavbarToolBox() {
  await closeCurrentModal()
}

// ****************************************************
// ***************      PROFILE      ******************
// ****************************************************

export async function goBackInProfilePanel() {
  const panelHistory = getPanelHistory('profile')
  const [item] = panelHistory.slice(-2, -1)

  if (!item || item === 'INIT') popPanelFromSection('left')
  else popFromPanelNew('profile')
}

// MY_ACCOUNT
export async function switchToMyAccount() {
  pushToPanelNew('profile', 'profile/MY_ACCOUNT')
}

export const closeMyAccount = goBackInProfilePanel

// EDIT_ACCOUNT
export async function openEditAccount() {
  pushToPanelNew('profile', 'profile/EDIT_ACCOUNT')
}

export const closeEditAccount = goBackInProfilePanel

// PREMIUM_FEATURES
export async function openPremiumFeaturesIntroduction() {
  pushToPanelNew('profile', 'profile/PREMIUM_FEATURES_INTRODUCTION')
}

export const closePremiumFeatures = goBackInProfilePanel

// PREMIUM_FEATURES_REQUEST_FORM
export async function openPremiumFeaturesRequestForm() {
  pushToPanelNew('profile', 'profile/PREMIUM_FEATURES_REQUEST_FORM')
}

export const closePremiumFeaturesRequestForm = goBackInProfilePanel

// PRIVACY_POLICY
export async function openPrivacyPolicy() {
  pushToPanelNew('profile', 'profile/PRIVACY_POLICY')
}

export const closePrivacyPolicy = goBackInProfilePanel

// EDIT_BIO
export async function openEditBio() {
  pushToPanelNew('profile', 'profile/EDIT_BIO')
}

export const closeEditBio = goBackInProfilePanel

// EDIT_USERNAME
export async function openEditUsername() {
  pushToPanelNew('profile', 'profile/EDIT_USERNAME')
}

export const closeEditUsername = goBackInProfilePanel

// CONTACTS
export async function openContacts() {
  pushToPanelNew('profile', 'profile/CONTACTS')
}

export const closeContacts = goBackInProfilePanel

// ADD_CONTACT
export async function openAddContact() {
  pushToPanelNew('profile', 'profile/ADD_CONTACT')
}

export const closeAddContact = goBackInProfilePanel

// EDIT_CONTACT
export async function openEditContact(userId: string, addMode?: boolean) {
  const activeSection = getSectionsHistoryTop()
  if (activeSection === 'right') {
    // TODO[router]: What the actual Khuck should we do to avoid these complications?
    resetPanel('room')

    pushToPanelNew('profile', 'profile/EDIT_CONTACT', { userId, addMode })
    pushToPanelNew('profile', 'profile/EDIT_CONTACT', { userId, addMode })
  }
}

export const closeEditContact = goBackInProfilePanel

// SETTINGS
export async function openSettings() {
  pushToPanelNew('profile', 'profile/SETTINGS')
}

export const closeSettings = goBackInProfilePanel

export async function openDeleteAccount() {
  pushToPanelNew('profile', 'profile/DELETE_ACCOUNT')
}

export const closeDeleteAccount = goBackInProfilePanel

// FAQ
export async function openFAQ() {
  pushToPanelNew('profile', 'profile/FAQ')
}

export const closeFAQ = goBackInProfilePanel

// CONTACT_US
export async function openContactUs() {
  pushToPanelNew('profile', 'profile/CONTACT_US')
}

export const closeContactUs = goBackInProfilePanel

// INVITE_FRIENDS
export async function openInviteFriends() {
  pushToPanelNew('profile', 'profile/INVITE_FRIENDS')
}

export const closeInviteFriends = goBackInProfilePanel

// INVITE_VIA_PHONE
export async function openInviteViaPhone() {
  pushToPanelNew('profile', 'profile/INVITE_VIA_PHONE')
}

export const closeInviteViaPhone = goBackInProfilePanel

// INVITE_FROM_CONTACTS
export async function openInviteFromContacts(limit: number) {
  pushToPanelNew('profile', 'profile/INVITE_FROM_CONTACTS', { limit })
}

export const closeInviteFromContacts = goBackInProfilePanel

// BLOCKED_USERS
export async function openBlockedUsers() {
  pushToPanelNew('profile', 'profile/BLOCKED_USERS')
}

export const closeBlockedUsers = goBackInProfilePanel

// BLOCK_USER
export async function openBlockUser() {
  pushToPanelNew('profile', 'profile/BLOCK_USER')
}

export const closeBlockUser = goBackInProfilePanel

// PRIVACY_TYPE_SETTINGS
export async function openPrivacyTypeSettings(privacyType: PrivacyType) {
  pushToPanelNew('profile', 'profile/PRIVACY_TYPE_SETTINGS', { privacyType })
}

export const closePrivacyTypeSettings = goBackInProfilePanel

// PRIVACY_EXCEPTION_USERS
export async function openPrivacyExceptionUsers(
  privacyType: PrivacyType,
  exceptionType: 'never' | 'always',
) {
  pushToPanelNew('profile', 'profile/PRIVACY_EXCEPTION_USERS', {
    privacyType,
    exceptionType,
  })
}

export const closePrivacyExceptionUsers = goBackInProfilePanel

// ADD_PRIVACY_EXCEPTION_USERS
export async function openAddPrivacyExceptionUsers(
  privacyType: PrivacyType,
  exceptionType: 'never' | 'always',
) {
  pushToPanelNew('profile', 'profile/ADD_PRIVACY_EXCEPTION_USERS', {
    privacyType,
    exceptionType,
  })
}

export const closeAddPrivacyExceptionUsers = goBackInProfilePanel

// ACTIVE_DEVICES
export async function openActiveDevices() {
  pushToPanelNew('profile', 'profile/ACTIVE_DEVICES')
}

export const closeActiveDevices = goBackInProfilePanel

// ****************************************************
// *************      ROOM_PROFILE      ***************
// ****************************************************

export async function goBackInRoomProfilePanel() {
  const panelHistory = getPanelHistory('roomProfile')
  const [item] = panelHistory.slice(-2, -1)

  if (!isDesktopSize() && (!item || item === 'INIT')) {
    const rightSectionHistory = getSectionHistory('right')
    if (!rightSectionHistory) return

    // TODO[router]: Find a better solution
    if (rightSectionHistory.length > 1) popPanelFromSection('right')
    else popFromSectionsHistory()

    // TODO[router]: replace with onRouterAnimationEnd when implemented
    setTimeout(() => popFromPanelNew('roomProfile'), 400)
  } else popFromPanelNew('roomProfile')
}

// USER_PROFILE
export async function openUserProfile(userId: string) {
  if (userId === getClientUserId()) await openRoom(getPrivateSpace().roomId)
  else pushToPanelNew('roomProfile', 'roomProfile/USER_PROFILE', { userId })
}

export const closeUserProfile = goBackInRoomProfilePanel

// WAPP_PROFILE
export async function openWappProfile(wappId: string) {
  if (!isDesktopSize()) resetSection('right')

  resetPanel('roomProfile')
  pushToPanelNew('roomProfile', 'roomProfile/WAPP_PROFILE', { wappId })
}

export const closeWappProfile = goBackInRoomProfilePanel

// HALL_PROFILE
export async function openHallProfile(roomId: string) {
  if (!isDesktopSize()) resetSection('right')

  resetPanel('roomProfile')
  pushToPanelNew('roomProfile', 'roomProfile/HALL_PROFILE', { roomId })
}

export const closeHallProfile = goBackInRoomProfilePanel

// HALL_SETTINGS
export async function openHallSettings(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/HALL_SETTINGS', { roomId })
}

export const closeHallSettings = goBackInRoomProfilePanel

// SHARE_CONTACT
export function openShareContactList(userId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/SHARE_CONTACT_LIST', { userId })
}

export const closeShareContactList = goBackInRoomProfilePanel

// HALL_SUBSCRIBERS
export async function openHallSubscribers(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/HALL_SUBSCRIBERS', {
    roomId,
  })
}

export const closeHallSubscribers = goBackInRoomProfilePanel

// ADD_HALL_MEMBERS
export async function openAddHallMembers(
  roomId: string,
  skippable: boolean,
  replace = false,
) {
  if (replace)
    replaceInPanelNew('roomProfile', 'roomProfile/ADD_HALL_MEMBERS', {
      roomId,
      skippable,
    })
  else
    pushToPanelNew('roomProfile', 'roomProfile/ADD_HALL_MEMBERS', {
      roomId,
      skippable,
    })
}

export const closeAddHallMembers = goBackInRoomProfilePanel

export const openJoinHallRequests = (roomId: string) => {
  pushToPanelNew('roomProfile', 'roomProfile/JOIN_HALL_REQUESTS', {
    roomId,
  })
}

export const closeJoinHallRequests = goBackInRoomProfilePanel

// HALL_ADMINS
export async function openHallAdmins(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/HALL_ADMINS', {
    roomId,
  })
}

export const closeHallAdmins = goBackInRoomProfilePanel

// ADD_HALL_ADMIN
export async function openAddHallAdmin(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/ADD_HALL_ADMIN', {
    roomId,
  })
}

export const closeAddHallAdmin = goBackInRoomProfilePanel

// CHANNEL_ADMIN_PERMISSIONS
export async function openEditChannelAdminPermissions(
  hallId: string,
  userId: string,
) {
  pushToPanelNew('roomProfile', 'roomProfile/CHANNEL_ADMIN_PERMISSIONS', {
    hallId,
    userId,
    mode: 'EDIT',
  })
}

export async function openDefineChannelAdminPermissions(
  hallId: string,
  userId: string,
) {
  pushToPanelNew('roomProfile', 'roomProfile/CHANNEL_ADMIN_PERMISSIONS', {
    hallId,
    userId,
    mode: 'DEFINE',
  })
}

export const closeChannelAdminPermissions = goBackInRoomProfilePanel

// EDIT_GROUP_ADMIN_PERMISSIONS
export async function openEditGroupAdminPermissions(
  hallId: string,
  userId: string,
) {
  pushToPanelNew('roomProfile', 'roomProfile/GROUP_ADMIN_PERMISSIONS', {
    hallId,
    userId,
    mode: 'EDIT',
  })
}

// GROUP_ADMIN_PERMISSIONS
export async function openDefineGroupAdminPermissions(
  hallId: string,
  userId: string,
) {
  pushToPanelNew('roomProfile', 'roomProfile/GROUP_ADMIN_PERMISSIONS', {
    hallId,
    userId,
    mode: 'DEFINE',
  })
}

export const closeGroupAdminPermissions = goBackInRoomProfilePanel

// GROUP_MEMBER_PERMISSIONS
export async function openGroupMemberPermissions(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/GROUP_MEMBER_PERMISSIONS', {
    roomId,
  })
}

export const closeGroupMemberPermissions = goBackInRoomProfilePanel

// GROUP_MEMBER_PERMISSIONS_OVERRIDE
export async function openDefineGroupMemberPermissionsOverride(
  hallId: string,
  userId: string,
) {
  pushToPanelNew(
    'roomProfile',
    'roomProfile/GROUP_MEMBER_PERMISSIONS_OVERRIDE',
    { hallId, userId, mode: 'DEFINE' },
  )
}

export async function openEditGroupMemberPermissionsOverride(
  hallId: string,
  userId: string,
) {
  pushToPanelNew(
    'roomProfile',
    'roomProfile/GROUP_MEMBER_PERMISSIONS_OVERRIDE',
    { hallId, userId, mode: 'EDIT' },
  )
}

export const closeGroupMemberPermissionsOverride = goBackInRoomProfilePanel

// GROUP_EXCEPTIONS
export async function openGroupExceptions(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/GROUP_EXCEPTIONS', { roomId })
}

export const closeGroupExceptions = goBackInRoomProfilePanel

// ADD_GROUP_EXCEPTION_MEMBER
export async function openAddGroupExceptionMember(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/ADD_GROUP_EXCEPTION_MEMBER', {
    roomId,
  })
}

export const closeAddGroupExceptionMember = goBackInRoomProfilePanel

// HALL_REMOVED_USERS
export async function openHallRemovedUsers(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/HALL_REMOVED_USERS', { roomId })
}

export const closeHallRemovedUsers = goBackInRoomProfilePanel

// HALL_REMOVE_MEMBER
export async function openHallRemoveMember(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/HALL_REMOVE_MEMBER', { roomId })
}

export const closeHallRemoveMember = goBackInRoomProfilePanel

// HALL_INVITE_LINKS
export async function openHallInviteLinks(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/HALL_INVITE_LINKS', { roomId })
}

export const closeHallInviteLinks = goBackInRoomProfilePanel

// CREATE_INVITE_LINK
export async function openCreateInviteLink(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/CREATE_INVITE_LINK', { roomId })
}

export const closeCreateInviteLink = goBackInRoomProfilePanel

// EDIT_INVITE_LINK
export async function openEditInviteLink(
  roomId: string,
  inviteLink: InviteLink,
) {
  pushToPanelNew('roomProfile', 'roomProfile/EDIT_INVITE_LINK', {
    roomId,
    inviteLink,
  })
}

export const closeEditInviteLink = goBackInRoomProfilePanel

// JOINED_VIA_INVITE_LINK
export async function openJoinedViaInviteLink(
  roomId: string,
  inviteLink: InviteLink,
) {
  pushToPanelNew('roomProfile', 'roomProfile/JOINED_VIA_INVITE_LINK', {
    roomId,
    inviteLink,
  })
}

export const closeJoinedViaInviteLink = goBackInRoomProfilePanel

// SELECT_WORKSPACE_NAME
export async function openSelectWorkspaceName(workspaceId?: string) {
  pushToPanelNew('roomProfile', 'roomProfile/SELECT_WORKSPACE_NAME', {
    workspaceId,
  })
}

export const closeSelectWorkspaceName = goBackInRoomProfilePanel

// SELECT_WORKSPACE_COLOR
export async function openSelectWorkspaceColor(
  name?: string,
  icon?: string,
  workspaceId?: string,
) {
  pushToPanelNew('roomProfile', 'roomProfile/SELECT_WORKSPACE_COLOR', {
    name,
    icon,
    workspaceId,
  })
}

export const closeSelectWorkspaceColor = goBackInRoomProfilePanel

// CREATE_HALL
export async function openCreateHall(hallType: HallType, tags?: string[]) {
  pushToPanelNew('roomProfile', 'roomProfile/CREATE_HALL', {
    hallType,
    tags,
  })
}

// HALL_ADVANCED_SETTINGS
export async function openDefineHallAdvancedSettings(
  roomId: string,
  replace = false,
) {
  if (replace) {
    resetPanel('roomProfile')
    replaceInPanelNew(
      'roomProfile',
      'roomProfile/DEFINE_HALL_ADVANCED_SETTINGS',
      {
        roomId,
      },
    )
  } else
    pushToPanelNew('roomProfile', 'roomProfile/DEFINE_HALL_ADVANCED_SETTINGS', {
      roomId,
    })
}
export const closeDefineHallAdvancedSettings = goBackInRoomProfilePanel

export const closeCreateHall = goBackInRoomProfilePanel

// FORWARD_LIST
export async function openForwardList(
  onConfirm: (roomIds: string[], caption?: string) => unknown,
  forwardLimit: number = null,
  onSelect?: (roomId: string) => unknown,
  selectOnTap?: boolean,
) {
  resetUserPermissions()
  pushToPanelNew('roomProfile', 'roomProfile/FORWARD_LIST', {
    onConfirm,
    forwardLimit,
    onSelect,
    selectOnTap,
  })
}

export const closeForwardList = goBackInRoomProfilePanel

// SHARED_MEDIA
export async function openSharedMedia(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/SHARED_MEDIA', {
    roomId,
    selectionMode: false,
  })
}

export const closeSharedMedia = goBackInRoomProfilePanel

// USER_SESSIONS_LIMIT
export async function openUserSessionsLimit(roomId: string) {
  pushToPanelNew('roomProfile', 'roomProfile/USER_SESSIONS_LIMIT', { roomId })
}

export const closeUserSessionsLimit = goBackInRoomProfilePanel

// ****************************************************
// *****************      ROOM      *******************
// ****************************************************

export async function goBackInRoomPanel() {
  const { location, state } = getPanelTop('room') || {}
  if (isDesktopSize() || location === 'room/pins') {
    popFromPanelNew('room')
    return
  }

  const mode = state?.mode
  if (!mode) {
    // TODO[router]: Disable router animation for reset panels

    resetPanel('roomProfile')
    resetPanel('wapp')
    resetSection('right')
    resetSectionsHistory('left', 'mid')
    await asyncDelay(0)

    popFromSectionsHistory()
    // TODO[router]: Refactor using onAnimationEnd
    await asyncDelay(300)

    resetPanel('room')
    resetSection('mid')
  } else popFromPanelNew('room')
}

// ROOM
export function openRoomPage(roomId: string) {
  const topLocation = getPanelTop('room')?.location

  if (topLocation === 'startPage')
    pushToPanelNew('room', 'room/room', { roomId })
  else replaceInPanelNew('room', 'room/room', { roomId })
}

export function openRoomPins() {
  const roomId = getOpenedRoomId()
  pushToPanelNew('room', 'room/pins', { roomId })
}

export const closeRoom = () => {
  lastOpenedRoomMessagesService.syncOpenedRoomWithLastOpenedRoomMessages()
  goBackInRoomPanel()
}

export const closeRoomPins = closeRoom

// ROOM_SELECTION_MODE
export async function setRoomToSelectionMode(roomId: string) {
  pushToPanelNew('room', 'room/room', { mode: 'SELECT', roomId })
}

export const exitRoomFromSelectionMode = goBackInRoomPanel

// ROOM_SEARCH_MODE

export function handleUrlToLoadAfterLogin() {
  const url = urlToLoadAfterLoginStorage.get()
  if (url) {
    handleLink(url)
    urlToLoadAfterLoginStorage.remove()
  }
}
